<template>

        <div
          class="fixed inset-0 z-50 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true">
          <div
            class="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div
              class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
              aria-hidden="true"></div>

            <span
              class="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true">&#8203;</span>

            <div
              class="inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle w-full sm:max-w-2xl sm:w-full sm:p-6 lg:max-w-7xl">
              <div>

                <div v-if="!gallery.length">
                    <ul
                  role="list"
                  class="grid grid-cols-2 gap-x-4 gap-y-4 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-4">

                  <li class="relative">
                    <div
                      class="block bg-gray-100 rounded-lg w-fulloverflow-hidden group aspect-w-10 aspect-h-7 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500">
                      <span class="p-8">There's nothing here just yet. <span class="text-2xl">😢</span></span>
                    </div>
                  </li>

                </ul>
                </div>
                <ul v-else
                  role="list"
                  class="grid grid-cols-2 gap-x-4 gap-y-4 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-4">

                  <template v-for="item in gallery">
                  <li class="relative">
                    <a :href="item.uri" download="PoseXR" target="_blank"
                      class="block w-full overflow-hidden bg-gray-100 rounded-lg cursor-pointer group aspect-w-10 aspect-h-7 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-offset-gray-100 focus-within:ring-indigo-500">
                      <img
                        :src="item.uri"
                        alt=""
                        class="object-cover pointer-events-none group-hover:opacity-75"
                      />
                    </a>
                  </li>
                  </template>

                </ul>
              </div>
              <div class="mt-5 sm:mt-6">
                <button
                    @click.prevent="$emit('close')"
                  type="button"
                  class="inline-flex justify-center w-full px-4 py-2 text-base font-medium text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
                  Go back to camera
                </button>
              </div>
            </div>
          </div>
        </div>
</template>
<script>
export default {
    props: {
        gallery: {
            type: Array,
            default: () => []
        }
    }
}
</script>
